<template>
  <pt-modal
    ref="orderDetailsModal"
    size="large"
    no-border
    class="custom-modal overflow-y-scroll"
  >
    <div slot="modal-header" class="flex justify-between text-xl">
      <div class="w-3/4">
        <div class="md:flex mb-2">
          <p class="font-bold pb-2 text-base flex flex-col md:flex-row items-start md:items-center">
            <span class="mb-2 md:mb-0">Token ID {{ selectedOrder.serial_no }}</span>
            <span class="handover-status text-sm py-1 px-2 font-bold ml-0 md:ml-4">{{ selectedOrder.status }}</span>
          </p>
        </div>
        <p class="order-date py-2 text-sm text-grey-dark flex sm:flex-col lg:flex-row">
          <span> Order ID# {{ selectedOrder.tracking_id }} </span>
          <span class="hidden lg:block">
            &nbsp; |&nbsp; &nbsp;
          </span>
          <span class="mt-1 lg:mt-0">
            {{ orderDate }}
          </span>
        </p>
      </div>
      <div>
        <button @click="close">
          <i class="fa fa-times" aria-hidden="true" />
        </button>
      </div>
    </div>
    <div slot="modal-body">
      <div class="w-full overflow-y-auto max-height-screen">
        <div v-if="hasSelectedOrder" class="bg-white">
          <!-- Customer details -->
          <div v-if="isChain" class="p-4 my-4 bg-grey-light rounded">
            <div class="card-header">
              <p class="pb-4 leading-normal font-bold text-lg">Customer</p>
            </div>
            <div class="flex flex-col lg:flex-row w-full">
              <div class="flex lg:w-1/2">
                <img
                  :src="
                    selectedOrder.user_details.profile_pic
                      ? 'https://cdn.pathao.com/' + selectedOrder.user_details.profile_pic
                      : '/img/default-user.3c1dd009.png'
                  "
                  alt="customer-img"
                  class="w-12 h-12 rounded-full"
                />
                <div class="ml-4 text-base">
                  {{ selectedOrder.user_details.name }} <br />
                  <div class="mt-2 font-bold">{{ selectedOrder.user_details.number }}</div>
                </div>
              </div>
              <div class="flex lg:w-1/2 mt-4 lg:mt-0 ml-2 inline items-center">
                <i class="fa fa-map-marker fa-3x text-primary" />
                <span class="mt-1 ml-4">{{ selectedOrder.user_details.order_address }}</span>
              </div>
            </div>
          </div>
          <!-- Prescription -->
          <div
            v-if="selectedOrder.images && selectedOrder.images.length > 0"
            class="order-details-card border block mb-4"
          >
            <div class="bg-grey-lighter py-4">
              <p class="card-title px-4"><i class="fa fa-file text-primary" /> Prescription</p>
            </div>
            <pt-photo-gallery
              ref="gallery"
              :images="selectedOrder.images"
              title="Prescription"
            />
            <div class="flex w-full">
              <div
                v-for="(image, index) in selectedOrder.images"
                :key="index"
                class="prescription cursor-pointer w-1/6 h-1/4 float-left m-4 border-solid border-red"
                title="Click to full view"
              >
                <img
                  :src="image.image_thumb_presigned"
                  :alt="image.id"
                  @click="setIndex(index)"
                />
              </div>
            </div>
          </div>
          <div class="order-details-card border block">
            <p class="card-title px-4 bg-grey-lighter py-4">Order Details</p>
            <div class="invoice p-4">
              <div class="invoice-items mb-4">
                <div
                  v-for="m in selectedOrder.items"
                  :key="m.id"
                  class="flex item pb-5 border-b border-dashed mb-4 w-full"
                >
                  <div class="w-full flex">
                    <p class="w-8 pr-6 font-semibold">{{ m.quantity }}x</p>
                    <div class="w-2/5">
                      <p class="font-semibold pb-2">{{ m.name }}</p>
                      <div class="">
                        <div v-if="m.addons_required.length" class="food-extra alt">
                          <h4 class="pb-2">Required Addons</h4>
                          <ul class="list-reset">
                            <li
                              v-for="y in m.addons_required"
                              :key="y.id"
                              class="pl-2 pb-1"
                            >
                              -{{ y.item_name }} ({{ y.price }} {{ isBDPhoneNumber() ? 'TK' : 'NPR' }})
                            </li>
                          </ul>
                        </div>
                        <div v-if="m.addons_optional.length" class="food-extra alt">
                          <h4 class="pb-2">Optional Addons</h4>
                          <ul class="list-reset">
                            <li
                              v-for="y in m.addons_optional"
                              :key="y.id"
                              class="pl-2"
                            >
                              -{{ y.item_name }} ({{ y.price }} {{ isBDPhoneNumber() ? 'TK' : 'NPR' }})
                            </li>
                            <li v-if="m.note" class="pl-2">Additional Information: {{ m.note }}</li>
                          </ul>
                        </div>
                        <div v-if="m.note" class="food-extra alt">
                          <h4 class="pb-2" />
                          <ul class="list-reset">
                            {{
                              m.note
                            }}
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="w-full text-right">
                      <p>
                        <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" /> <span v-else>रू</span>
                        {{ m.undiscounted_total || m.gross_amount }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex">
                <div v-if="selectedOrder.user_details.order_additional_info" class="flex w-3/5">
                  <div class="w-8" />
                  <div class="w-2/3">
                    <p class="font-semibold">Additional Instruction:</p>
                    <p>{{ selectedOrder.user_details.order_additional_info }}</p>
                  </div>
                </div>
                <div class="w-2/5 invoice-amount lg:flex lg:flex-row-reverse">
                  <div class="w-full">
                    <div class="border-b border-dashed border-red-light mb-1 amount-properties">
                      <div class="flex justify-between pb-4">
                        <p>Total Item Price</p>
                        <p>
                          <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>{{ selectedOrder.item_price.toFixed(2) }}
                        </p>
                      </div>
                      <div class="flex justify-between pb-4">
                        <p>Vat</p>
                        <p>
                          <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>{{ selectedOrder.vat.toFixed(2) }}
                        </p>
                      </div>
                      <div class="flex justify-between pb-4">
                        <p>Service charge</p>
                        <p>
                          <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>{{ selectedOrder.sc.toFixed(2) }}
                        </p>
                      </div>
                      <div v-if="isChain" class="flex justify-between pb-4">
                        <p>Delivery Fee</p>
                        <p>
                          <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>{{ selectedOrder.delivery_fee.toFixed(2) || 0 }}
                        </p>
                      </div>
                      <div v-if="isChain" class="flex justify-between pb-4">
                        <p>Pathao Promo</p>
                        <p class="text-red">
                          -<i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>
                          {{ selectedOrder.promo.toFixed(2) }}
                        </p>
                      </div>
                      <div
                        v-if="!selectedOrder.resto_discount_share && selectedOrder.restaurant_discount"
                        class="flex justify-between pb-4"
                      >
                        <p>Restaurant Discount</p>
                        <p class="text-red">
                          - <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>
                          {{ selectedOrder.restaurant_discount }}
                        </p>
                      </div>
                      <div v-if="isChain && selectedOrder.bnpl_discount_amount > 0" class="flex justify-between pb-4">
                        <p>Other Discount</p>
                        <p class="text-red">
                          - <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>
                          {{ selectedOrder.bnpl_discount_amount }}
                        </p>
                      </div>
                      <div v-if="selectedOrder.resto_discount_share" class="flex justify-between pb-4">
                        <p>Resto Share Discount</p>
                        <p class="text-red">
                          - <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>
                          {{ selectedOrder.resto_discount_share }}
                        </p>
                      </div>
                      <div v-if="selectedOrder.is_upfront && selectedOrder.mpf" class="flex justify-between pb-4">
                        <p>MPF</p>
                        <p class="text-red">
                          -<i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>
                          {{ selectedOrder.mpf }}
                        </p>
                      </div>
                      <div v-if="selectedOrder.is_upfront && selectedOrder.mpf" class="flex justify-between pb-4">
                        <p>Vat on MPF</p>
                        <p class="text-red">
                          -<i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>
                          {{ selectedOrder.vat_on_mpf }}
                        </p>
                      </div>
                    </div>
                    <div class="total border-t border-dashed border-red-light font-bold">
                      <div class="flex justify-between pt-4">
                        <p class="text-base font-semibold">Total Collectible</p>
                        <p class="text-base font-semibold">
                          <i v-if="isBDPhoneNumber()" class="icon-ic icon-ic-taka" />
                          <span v-else>रू</span>
                          {{ selectedOrder.total_collectable }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="order-meta flex flex-col md:flex-row justify-between lg:mb-2">
            <div v-if="selectedOrder.driver_details" class="carrier flex items-center mt-6 p-2 border">
              <img
                :src="'https://cdn.pathao.com/' + selectedOrder.driver_details.profile_pic"
                class="w-10 h-10 rounded-full mr-4"
                alt="driver image"
              />
              <div class="text-sm">
                <p class="font-bold">Carrier</p>
                <p class="text-black leading-none">{{ selectedOrder.driver_details.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="modal-footer">
      <div class="flex w-full sm:flex-col md:flex-row md:justify-left">
        <div class="report">
          <pt-button
            v-if="selectedOrder.status === 'PLACED'"
            variant="primary"
            class="sm:w-full md:w-auto md:px-4 my-1 mr-1"
            @action="processOrder(selectedOrder)"
          >
            Processing
          </pt-button>
          <pt-button
            v-if="selectedOrder.status === 'PROCESSING'"
            variant="primary"
            class="sm:w-full md:w-auto md:px-4 my-1 mr-1"
            @action="handOver(selectedOrder)"
          >
            Handover
          </pt-button>
          <pt-button
            v-if="isChain && selectedOrder.status === 'HANDOVER'"
            variant="primary"
            class="sm:w-full md:w-auto md:px-4 my-1 mr-1 complete-btn"
            @action="completeDelivery(selectedOrder)"
          >
            Complete Delivery
          </pt-button>
          <pt-button
            v-if="selectedOrder.status !== 'HANDOVER'"
            variant="secondary-outline"
            class="sm:w-full md:w-auto md:px-4 my-1"
            @action="openSupportContentModal(selectedOrder)"
          >
            Support
          </pt-button>
        </div>
      </div>
    </div>
  </pt-modal>
</template>

<script>
import { PtForm, PtModal } from '@pathao/ui-components';
import isChain from '@src/mixins/isChain';
import isBDPhoneNumber from '@src/utils/isBdNumber';
import isEmpty from 'lodash/isEmpty';

export default {
  components: {
    PtModal,
    PtForm,
  },
  mixins: [isChain],
  props: {
    selectedOrder: {
      type: Object,
      default: null,
    },
    orderDate: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    hasSelectedOrder() {
      return !isEmpty(this.selectedOrder);
    },
  },
  methods: {
    isBDPhoneNumber,
    show() {
      this.$refs.orderDetailsModal.showModal();
    },
    close() {
      this.$emit('detailsModalClosed');
      this.$refs.orderDetailsModal.closeModal();
    },
    submit() {},
    processOrder(selectedOrder) {
      this.$emit('onProcessOrder', selectedOrder);
    },
    handOver(selectedOrder) {
      this.$emit('onHandOver', selectedOrder);
    },
    completeDelivery(selectedOrder) {
      this.$emit('onCompleteDelivery', selectedOrder);
    },
    openSupportContentModal(selectedOrder) {
      this.$emit('onOpenSupportContentModal', selectedOrder);
    },
  },
};
</script>
